import {schoolSearchActionTypes as types} from '../constants';

export function initializeUserSchoolUpdate(payload) {
  return {
    type: types.INITIALIZE_USER_SCHOOL_UPDATE_REQUEST,
    payload
  };
}

export function getSchoolSearchSuccess() {
  return {type: types.SCHOOL_SEARCH_LOAD_SUCCESS};
}

export function getSchoolSearchFailure(error) {
  return {type: types.SCHOOL_SEARCH_LOAD_FAILURE, error};
}

export function requestSchools(payload) {
  return {
    type: types.SCHOOLS_LOAD_REQUEST,
    payload
  };
}

export function requestSchoolsSuccess(payload) {
  return {type: types.SCHOOLS_LOAD_SUCCESS, payload};
}

export function requestSchoolsFailure(error) {
  return {type: types.SCHOOLS_LOAD_FAILURE, error};
}
